export const AUTH_TOKEN = 'auth_token'
export const AUTH_TYPE = 'auth_type'
export const AUTH_ROLES = 'auth_roles'
export const AUTH_ID = 'auth_id'
export const AUTH_NAME = 'auth_name'
export const AUTH_USER = 'auth_user'
export const AUTH_SESSION_EXPIRY = 'expiresAt'
export const AUTH_DEVICE_TOKEN = 'devicetoken'
export const ADMIN_TYPE = 'Admin'
export const SUBADMIN_TYPE = 'Sub Admin'

/** Admin panel login: Admin + Sub-admin (API may use hyphen or space). */
export const ALLOWED_LOGIN_USER_TYPES = [
  ADMIN_TYPE,
  SUBADMIN_TYPE,
  'Sub-admin',
]

export const isAllowedAdminPanelLoginType = (userType) =>
  ALLOWED_LOGIN_USER_TYPES.includes(userType)

/** Sidebar items always visible (not in PermissionsConfig / role matrix). */
export const PUBLIC_NAV_KEYS = [
  'dashboards-default',
  'docs-documentation',
  'docs-changelog',
]

export const PASSWORD_FORM_RULES = [
  { required: true, message: 'Password is required' },
  { min: 8, message: 'Password must have at least 8 characters' },
  {
    pattern:
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]+$/,
    message:
      'Password must contain uppercase, lowercase, number and special character (@$!%*?&#)',
  },
]
